import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createEventsPageEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackEventPageOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.EVENT_PAGE_OPEN,
      properties: { source },
    });

  const trackEventsDrawerOpen = (source: PosthogTrackingSource, type: string) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.EVENTS_DRAWER_OPEN,
      properties: { source, type },
    });

  return {
    trackEventPageOpen,
    trackEventsDrawerOpen,
  };
};
